class FeaturedCollectionTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll(".tab-button");
    this.tabCollections = this.querySelectorAll(
      ".product-carousel-wrapper--tabs"
    );
    this.swiper = this.querySelectorAll(".product-tabs-swiper.swiper");
    this.viewAllButtons = document.querySelectorAll(".collection-tabs-section-link");
    this.activeTab = this.querySelector(".tab-active");
  }

  connectedCallback() {
    this.updateActiveTab();
    this.initSwiper();
    this.viewAllButtons.forEach((button) => {
      button.setAttribute("href", this.activeTab.getAttribute("data-collection-url"));
    });
  }

  updateActiveTab() {
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const tabCollectionHandle = tab.getAttribute(
          "data-tab-collection-handle"
        );
        const tabCollectionUrl = tab.getAttribute(
          "data-collection-url"
        );
        console.log(tabCollectionUrl)
        this.tabs.forEach((tab) => {
          tab.classList.remove("tab-active");
        });
        tab.classList.add("tab-active");
        this.tabCollections.forEach((collection) => {
          collection.classList.remove("active-collection");
          if (
            collection.getAttribute("data-tab-collection-handle") ===
            tabCollectionHandle
          ) {
            collection.classList.add("active-collection");
            this.viewAllButtons.forEach((button) => {
              button.setAttribute("href", tabCollectionUrl);
            });
          }
        });
      });
    });
  }

  initSwiper() {
    this.swiper.forEach((swiper) => {
      const parentContainer = swiper.closest(".product-carousel-wrapper--tabs");
      const swiperButtonPrev = parentContainer.querySelector(
        ".swiper-button-prev"
      );
      const swiperButtonNext = parentContainer.querySelector(
        ".swiper-button-next"
      );
      const swiperScrollbar =
        parentContainer.querySelector(".swiper-scrollbar");

      new Swiper(swiper, {
        slidesPerView: 1.4,
        spaceBetween: 8,
        autoHeight: false,
        observer: true,
        observeParents: true,
        breakpoints: {
          768: {
            slidesPerView: 3,
          },
          990: {
            slidesPerView: 4.2,
          },
        },
        navigation: {
          nextEl: swiperButtonNext,
          prevEl: swiperButtonPrev,
        },
        scrollbar: {
          el: swiperScrollbar,
          draggable: true,
        },
      });
    });
  }
}

if (customElements.get("featured-collection-tabs") === undefined) {
  customElements.define("featured-collection-tabs", FeaturedCollectionTabs);
}
